export function rateFactory($resource, MyConstant) {
    "ngInject"

    return $resource('', {}, {
        'productRate': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}ECBUserRate/GetProductRateType`,
            isArray: true
        },
        'vendorRate': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}ECBUserRate/GetVendorRateType`,
            isArray: true
        },
        'vendorVote': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}ECBUserRate/SaveVendorRateList`
        },
        'vote': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}ECBUserRate/SaveProductRateList`
        }

    })
}


// WEBPACK FOOTER //
// ./src/factories/rate/rate.ts